<template>
    <div id="MyResultDiv">
        <HeaderVue />
        <div class="blue-title-bar">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2>My Results</h2>
                    </div>
                </div>
            </div>
        </div>
        <router-link to="/referral/invite" class="w-100 referal-image" >
            <img src="static/images/referral_web_banner.jpg" class="responsive-result-image" alt="" />
        </router-link>
        <div class="inner-page-result phleb-signup my-profile">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="my-result">
                            <div class="table-responsive">
                                <table class="table black-color">
                                    <thead class="grey-section">
                                        <tr>
                                            <th style="">Request No</th>
                                            <th>Patient Name</th>
                                            <th>Date/ Time</th>
                                            <th>Test/ Profile</th>
                                            <th>Lab Name/ Locality</th>
                                            <th>Report Date</th>
                                            <th style="text-align: center">Result Status</th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="(item, index) in limitBy(totalReports, reportLimit)" :key="index">
                                        <tr>
                                            <td>REQ{{item.requestId}}</td>
                                            <td>{{item.reqPatientFirstName+ ' '+ item.reqPatientLastName}}</td>
                                            <td>
                                              {{formatDate((item.appointmentDate), 'dd/mm/yyyy')}}<br>
                                              {{item.appointmentFromTime}} - {{item.appointmentToTime}}
                                            </td>
                                            <td><span>{{(item.requestTestList).join(', ')}}</span></td>
                                            <td>
                                                {{item.labName}}<br>
                                                <span class="grey-color">{{item.labLocation+', '+item.labCity+' - '+item.labZipcode}}</span>
                                            </td>
                                            <td>{{(item.reportDeliveredDate)?(formatReportDate(item.reportDeliveredDate, 'dd/mm/yyyy hh:MM TT')):'-' }}</td>
                                            <td>
                                                <h6 class="m-0 text-danger text-uppercase"  v-if="item.requestStatus === -1" >Payment Pending</h6>
                                                <h6 class="m-0 text-danger text-uppercase"  v-if="item.requestStatus === -2" >Payment Failure</h6>
                                                <h6 class="m-0 text-success text-uppercase"  v-if="item.requestStatus === 0 || item.requestStatus === 2" >Requested</h6>
                                                <h6 class="m-0 text-warning text-uppercase"  v-if="item.requestStatus === 1 || item.requestStatus === 12" >Phelebotomist Accepted</h6>
                                                <!--<h6 class="m-0 text-warning"  v-if="item.requestStatus === 2" >Phelebotomist Cancelled</h6>-->
                                                <h6 class="m-0 text-warning text-uppercase"  v-if="item.requestStatus === 3" >Sample Collected</h6>
                                                <h6 class="m-0 text-success text-uppercase"  v-if="item.requestStatus === 4 || item.requestStatus === 5 || item.requestStatus === 7" >Sample Delivered to Lab</h6>
                                                <!--<h6 class="m-0 text-warning"  v-if="item.requestStatus === 5" >Report Pending for </h6>-->
                                                <!--<h6 class="m-0 text-warning"  v-if="item.requestStatus === 6" v-on:click="viewReport(item.requestId)">View PDF</h6>-->
                                                <!--<h6 class="m-0 text-warning"  v-if="item.requestStatus === 7" >Report Rejected</h6>-->
                                                <h6 class="m-0 text-danger text-uppercase"  v-if="item.requestStatus === 8" >Cancelled</h6>
                                                <h6 class="m-0 text-secondary text-uppercase"  v-if="item.requestStatus === 9" >Refund</h6>
                                                <h6 class="m-0 text-danger text-uppercase"  v-if="item.requestStatus === 11" >Payment Processing</h6>
                                                <!--<button class="btn btn-sm text-nowrap btn-warning" v-if="item.requestStatus === -1">Payment Pending</button>
                                                <button class="btn btn-sm text-nowrap btn-outline-danger" v-if="item.requestStatus === -2">Payment Failure</button>
                                                <button class="btn btn-sm text-nowrap btn-success" v-else-if="item.requestStatus === 0">Requested</button>
                                                <button class="btn btn-sm text-nowrap btn-outline-warning" v-else-if="item.requestStatus === 1">Phelebotomist Accepted</button>
                                                <button class="btn btn-sm text-nowrap btn-outline-warning" v-else-if="item.requestStatus === 2">Phelebotomist Cancelled</button>
                                                <button class="btn btn-sm text-nowrap btn-outline-warning" v-else-if="item.requestStatus === 3">Sample Collected</button>
                                                <button class="btn btn-sm text-nowrap btn-outline-warning" v-else-if="item.requestStatus === 4">Sample Delivered</button>
                                                <button class="btn btn-sm text-nowrap btn-outline-warning" v-else-if="item.requestStatus === 5">Report Pending</button>-->
                                                <button class="btn btn-sm text-nowrap btn-primary" v-else-if="item.requestStatus === 6" v-on:click="viewReport(item.requestId)">View PDF</button>
                                                <!--<button class="btn btn-sm text-nowrap btn-outline-danger" v-else-if="item.requestStatus === 7">Report Rejected</button>
                                                <button class="btn btn-sm text-nowrap btn-sm btn-outline-secondary" v-else-if="item.requestStatus === 8">Cancelled</button>
                                                <button class="btn btn-sm text-nowrap btn-danger" v-else-if="item.requestStatus === 9">Refund</button>-->
                                            </td>
                                        </tr>
                                        <!--<tr>
                                            <td class="border-top-0"></td>
                                            <td class="border-top-0" colspan="4">
                                                <div class="alert alert-warning" role="alert">
                                                    <div class="row">
                                                        <div class="col-sm-12">
                                                            <table>
                                                                <tr v-if="item.requestStatus >= 0 && item.requestStatus < 5">
                                                                    <td class="no-border">
                                                                        <p class="m-0">
                                                                            <i class="fa fa-exclamation-circle grey-color alert-icon"></i>
                                                                        </p>
                                                                    </td>
                                                                    <td class="no-border">
                                                                        <p class="m-0">Our Phelebotomist will visit your place as per your
                                                                            scheduled date and time, If any case, if you
                                                                            want to cancel the appointment , to be cancelled
                                                                            4 hrs in advance. T&C</p>
                                                                    </td>
                                                                    <td class="border-left border-top-0">
                                                                        <button class="btn btn-link text-nowrap">
                                                                            Cancel Appointment
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                                <tr v-if="item.requestStatus === -2">
                                                                    <td class="no-border">
                                                                        <p class="m-0">
                                                                            <i class="fa fa-exclamation-circle grey-color alert-icon"></i>
                                                                        </p>
                                                                    </td>
                                                                    <td class="no-border">
                                                                        <p class="m-0">An error was encountered duing the payment process.
                                                                            Your payment could not be completed. Try to place
                                                                            the order with a differnet payment method to
                                                                            process your appointment.</p>
                                                                    </td>
                                                                    <td class="border-left border-top-0">
                                                                        <button class="btn btn-link text-nowrap">
                                                                            Place Oder
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                                <tr v-if="item.requestStatus === 6">
                                                                    <td class="no-border">
                                                                        <p class="m-0">
                                                                            <i class="fa fa-exclamation-circle grey-color alert-icon"></i>
                                                                        </p>
                                                                    </td>
                                                                    <td class="no-border">
                                                                        <p class="m-0">Your report is geneated, you can dowload the PDF. </p>
                                                                    </td>
                                                                    <td class="border-top-0">
                                                                        
                                                                    </td>
                                                                </tr>
                                                                <tr v-if="item.requestStatus === 8 || item.requestStatus === 9">
                                                                    <td class="no-border">
                                                                        <p class="m-0">
                                                                            <i class="fa fa-exclamation-circle grey-color alert-icon"></i>
                                                                        </p>
                                                                    </td>
                                                                    <td class="no-border">
                                                                        <p class="m-0">Your appointment is cancelled </p>
                                                                    </td>
                                                                    <td class="border-top-0">
                                                                        
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="border-top-0"></td>
                                        </tr>-->
                                    </tbody>
                                    <tbody v-if="totalReports.length <= 0 && isLoading">
                                        <tr>
                                            <td colspan="6" align="center">Loading...</td>
                                        </tr>
                                    </tbody>
                                    <tbody v-if="totalReports.length <= 0 && !isLoading">
                                        <tr>
                                            <td colspan="6" align="center">No records found</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <button class="btn btn-outline-primary align-center" v-if="totalReports.length > reportLimit" v-on:click="loadMore()" >Show more Results({{totalReports.length - reportLimit}})</button>
                <!--({{totalReports.length - 10}})-->
            </div>
        </div>
        <pdfviewer @closepdf="closepdf" v-model="isshowpdf" :pdfurl="pdfurls" @pdferr="pdferr" :maxscale='4' :minscale='0.6' :scale='1.1' :desiredWidth="2"></pdfviewer>
        <FooterVue />
    </div>
</template>

<script>
import HeaderVue from '@/components/web/Header'
import FooterVue from '@/components/web/Footer'
import dateFormat from 'dateformat'
import detectBrowser from 'detect-browser'
import pdfviewer from '@/components/plugin/vue-pdfviewer'

export default {
  name: 'MyResult',
  props: [],
  components: {
    HeaderVue,
    FooterVue,
    pdfviewer
  },
  beforeCreate () {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' })
    }
  },
  data () {
    return {
      loadMorePerHit: 10,
      reportLimit: 10,
      totalReports: [],
      reportList: [],
      limitedReportList: [],
      isLoading: false,
      deviceData: undefined,
      pdfurls:'',
      isshowpdf:false
    }
  },
  created () {
    this.patientReports()
    this.deviceData = detectBrowser.detect()
  },
  methods: {
    closepdf(){
        this.isshowpdf = false
    },
    pdferr(errurl) {
        console.log(errurl);
        this.pdfurls = ''
        this.isshowpdf = false
        // alert('Unable to fetch Report try again')
        this.$Simplert.open({
            title: 'Oops',
            message: 'Unable to fetch Report try again',
            type: 'warning',
            disableOverlayClick: true,
            showXclose: true,
            useConfirmBtn: false,
            customCloseBtnText: 'OK'
        })
    },
    loadMore: function () {
      var increamented = this.reportLimit + this.loadMorePerHit
      this.reportLimit = increamented > this.totalReports.length ? this.totalReports.length : increamented
    },
    formatDate: function (date, format) {
      let dateSplit = date.split(' ')
      return dateFormat((dateSplit[0] + 'T' + dateSplit[1]), format, true)
    },
    formatReportDate: function (date, format) {
      return dateFormat(date, format)
    },
    patientReports: function () {
      try {
        this.reportList = []
        let data = {}
        this.isLoading = true
        Promise.resolve(this.$POST('patient/patientReports', data)).then(function (res) {
          if (res.response_code === 0) {
            this.totalReports = (res.response)
            this.isLoading = false
          } else {
            this.isLoading = false
          }
          this.$hidePageLoading()
        }.bind(this)).catch(function (err) {
          console.error(err)
        })
      } catch (e) {
        console.error(e)
      }
    },
    viewReport: function (requestId) {
      try {
        this.reportList = []
        let data = {
          requestId: requestId
        }
        Promise.resolve(this.$GET('patient/viewReport', data)).then(function (res) {
          if (res.response_code === 0) {
            try {
            //   var popupWindow = window.open(res.response.url, '_blank')
            //   popupWindow.focus()
              this.pdfurls = res.response.url
              this.isshowpdf = true
            } catch (e) {
              this.popupBlockerAlert()
            }
          } else {
            this.$Simplert.open({
              title: 'Oops',
              message: res.response_message,
              type: 'warning',
              disableOverlayClick: true,
              showXclose: true,
              useConfirmBtn: false,
              customCloseBtnText: 'OK'
            })
            // alert(res.response_message)
          }
        }.bind(this)).catch(function (err) {
          console.error(err)
        })
      } catch (e) {
        console.error(e)
      }
    },
    popupBlockerAlert: function () {
      if (this.deviceData.name === 'chrome' && this.deviceData.os.indexOf('Windows') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: `<div style="text-align: left; line-height: 25px;">
                    <strong>1. </strong> Click the <strong>Customize and control Google Chrome</strong> menu (the three horizontal bars in the upper right corner)<br>
                    <strong>2. </strong> Select <strong>Settings</strong>.<br>
                    <strong>3. </strong> Click the <strong>Show advanced settings...</strong> at the bottom.<br>
                    <strong>4. </strong> Under Privacy, click the <strong>Content Settings</strong> button.<br>
                    <strong>5. </strong> To disable the pop-up blocker check the <strong>Allow all sites to show pop-ups</strong> box.<br>
                    <strong>6. </strong> To enable pop-ups on specific sites, check <strong>Do not allow any site to show pop-ups</strong> (recommended) and click Exceptions and enter this URL(<strong>https://labotist.com</strong>).
                </div>`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        })
      } else if (this.deviceData.name === 'chrome' && this.deviceData.os.indexOf('Mac') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: `<div style="text-align: left; line-height: 25px;">
                    <strong>1. </strong> Click the <strong>Customize and control Google Chrome</strong> menu (the three horizontal bars in the upper right corner)<br>
                    <strong>2. </strong>  Select <strong>Settings</strong>.<br>
                    <strong>3. </strong> Click the <strong>Show advanced settings...</strong> at the bottom.<br>
                    <strong>4. </strong> Under <strong>Privacy</strong>, click the <strong>Content Settings</strong> button.<br>
                    <strong>5. </strong> To disable the pop-up blocker check the Allow all sites to show pop-ups box.<br>
                    <strong>6. </strong> To enable pop-ups on specific sites, check <strong>Do not allow any site to show pop-ups</strong> (recommended) and click Exceptions and enter this URL(<strong>https://labotist.com</strong>).<br>
                </div>`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        })
      } else if (this.deviceData.name === 'chrome' && this.deviceData.os.indexOf('Android') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: `<div style="text-align: left; line-height: 25px;">
                    <strong>1. </strong> To the right of the address bar, tap More  and then <strong>Settings</strong>.<br>
                    <strong>2. </strong>  Tap <strong>Site settings</strong> and then <strong>Pop-ups</strong>.<br>
                    <strong>3. </strong> Turn <strong>Pop-ups</strong> to <strong>Allowed</strong>.
                    </div>`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        })
      } else if (this.deviceData.name === 'crios' && this.deviceData.os.indexOf('iOS') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: `<div style="text-align: left; line-height: 25px;">
                    <strong>1. </strong> To the right of the address bar, tap More  and then <strong>Settings</strong>.<br>
                    <strong>2. </strong>  Tap <strong>Content Settings</strong> and then <strong>Block Pop-ups</strong>.<br>
                    <strong>3. </strong> Turn <strong>Block pop-ups</strong> off.
                </div>`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        })
      } else if (this.deviceData.name === 'safari' && this.deviceData.os.indexOf('Mac') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: `<div style="text-align: left; line-height: 25px;">
                    <strong>1. </strong> From the <strong>Safari</strong> menu, select <strong>Preferences</strong><br>
                    <strong>2. </strong>  Click <strong>Security</strong> at the top of the window<br>
                    <strong>3. </strong> Uncheck the <strong>Block pop-up windows</strong> box.
                </div>`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        })
      } else if (this.deviceData.name === 'ios' && this.deviceData.os.indexOf('iOS') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: `<div style="text-align: left; line-height: 25px;">
                    <strong>1. </strong> Launch <strong>Settings</strong>.<br>
                    <strong>2. </strong>  Tap <strong>Safari</strong>.<br>
                    <strong>3. </strong> Under the <strong>General section</strong>, click the toggle next to <strong>Block Pop-ups</strong> to <strong>disable</strong> the pop-up blocker. A green toggle indicates an enabled pop-up blocker.
                </div>`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        })
      } else if (this.deviceData.name === 'firefox' && this.deviceData.os.indexOf('Mac') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: `<div style="text-align: left; line-height: 25px;">
                    <strong>1. </strong> Select <strong>Preferences</strong> from the <strong>Firefox</strong> menu.<br>
                    <strong>2. </strong>  Choose the <strong>Content</strong> button.<br>
                    <strong>3. </strong> Uncheck the <strong>Block pop-up windows</strong> box.
                </div>`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        })
      } else if (this.deviceData.name === 'firefox' && this.deviceData.os.indexOf('Windows') > -1) {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: `<div style="text-align: left; line-height: 25px;">
                    <strong>1. </strong> Click the <strong>"hamburger" menu icon (top right) </strong> to open the Firefox menu.<br>
                    <strong>2. </strong> Click <strong>Options</strong>.<br>
                    <strong>3. </strong> Click <strong>Privacy & Security</strong> menu.<br>
                    <strong>4. </strong> Under <strong>Permission</strong> menu make sure that <strong>Block pop-up windows</strong> is activated (checkbox).<br>
                    <strong>5. </strong> Click the <strong>Exceptions</strong> button located to the right of Block pop-up windows.<br>
                    <strong>6. </strong> You will see the Allowed Sites dialog box.<br>
                    <strong>7. </strong> To enable add <strong>https://labotist.com</strong> and then click <strong>Allow</strong>
                </div>`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        })
      } else {
        this.$Simplert.open({
          title: 'Popup Blocked',
          message: `Pop-up Blocker is enabled! Please add this site to your exception list.`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button {
  cursor: pointer;
}
.phleb-signup { 
  background-image: none
}
</style>



// WEBPACK FOOTER //
// src/components/web/Secure/MyResult.vue